import styled from 'styled-components'

export const AppOutsideContainer = styled.div`
  background-color: ${props => props => props.theme.palette.background.default};
  color: ${props => props.theme.palette.text.primary};
`